import { API_BASE_URL, FAILURE, POST, GET, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function createConfiguracionExcelImportarSellers(obj) {
    try {
        let data = { error: true };
        const { code } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-sellers/create-configuracion-importar-excel-sellers",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            // data.error = false;
            data.error = false;
        }
        return data;
    } catch (err) {
        console.log("createConfiguracionExcelImportarSellers err");
        console.log(err);
        return { error: true };
    }
}

export async function obtenerConfiguracionExcelImportarSellers() {
    try {
        let data = { error: true };
        const { code, message, body } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-sellers/obtener-configuracion-importar-excel-sellers",
            {
                headers: getHeaders(),
                method: GET,
                // body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
            if (Array.isArray(body) === true && body.length > 0) {
                data.body = body[0];
            } else {
                data.body = null;
            }
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerConfiguracionExcelImportarSellers err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function actualizarConfiguracionExcelImportarSellers(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-sellers/actualizar-configuracion-importar-excel-sellers",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("actualizarConfiguracionExcelImportarSellers err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function guardarImportarExcelSellers(obj) {
    try {
        let data = { error: true };
        const { code, message } = await fetch(
            API_BASE_URL + "/configurar-importar-excel-sellers/guardar-importar-excel-sellers",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            data.error = false;
        }
        if (code === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("guardarImportarExcelSellers err");
        console.log(err);
        return { error: true, message: err };
    }
}
